import React, { useState } from "react";

import { toast } from "react-hot-toast";
import { Input } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import ModalBox from "components/modal/ModalBox";
import { addSubject } from "services/subject/subjectController";
import { addInterviewStudent } from "services/student/studentController";

const AddInterviewStudent = ({ open, onClose, interviewStudentListing }) => {
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [studentData, setStudentData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobile: ""
    });

    const [errorField, setErrorField] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobile: ""

    });

    //*********************Handel Validation********************************** */
    const handleValidation = () => {
        let errorField = {};
        let formIsValid = true;

        if (!studentData.firstName) {
            errorField["firstName"] = "Please Enter First Name";
            formIsValid = false;
        }
        if (!studentData.lastName) {
            errorField["lastName"] = "Please Enter Last Name";
            formIsValid = false;
        }
        if (!studentData.email) {
            errorField["email"] = "Please Enter Email ID";
            formIsValid = false;
        }
        if (!studentData.mobile) {
            errorField["mobile"] = "Please Enter Mobile";
            formIsValid = false;
        }

        setErrorField(errorField);
        return formIsValid;
    };

    // this function is used for clear data on close
    const modalOnClose = () => {
        setStudentData({
            firstName: "",
        });
        onClose();
    };

    //*********************Submit Subject Handler********************************** */
    const submitSubjectHandler = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const res = await addInterviewStudent({ firstName: studentData.firstName, lastName: studentData.lastName, email: studentData.email, mobile: studentData.mobile });
                if (res.code === 200) {
                    toast.success(res.message);
                    setSubmitLoading(false);
                    modalOnClose();
                    interviewStudentListing();
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }

        } else {
            toast.error("Please fill all the fields");
        }
    };

    const onChangeHandler = (e) => {
        const { name, value } = e.target;

        if (name === "email") {
            setStudentData({ ...studentData, email: value });
            return;
        }

        // only letters for names
        if ((name === "firstName" || name === "lastName") && !/^[a-zA-Z\s]*$/.test(value)) {
            return;
        }

        setStudentData({ ...studentData, [name]: value });
    };


    return (
        <>
            <ModalBox
                status={open}
                onClose={modalOnClose}
                title={"Add Interview Student"}
                customizedFooter={
                    <div>
                        <Button onClick={submitSubjectHandler} {...submitButtonElement}>
                            Add Student
                        </Button>
                    </div>
                }
            >
                <div className="form-group row">
                    {/* First Name */}
                    <div className="col-sm-6 col-form-label">
                        <Input
                            type="text"
                            name="firstName"
                            value={studentData.firstName}
                            onChange={onChangeHandler}
                            placeholder="Enter First Name"
                            className="form-control"
                            maxLength={30}
                            label="First Name"
                            error={errorField.firstName}
                            required
                        />
                    </div>

                    {/* Last Name */}
                    <div className="col-sm-6 col-form-label">
                        <Input
                            type="text"
                            name="lastName"
                            value={studentData.lastName}
                            onChange={onChangeHandler}
                            placeholder="Enter Last Name"
                            className="form-control"
                            maxLength={30}
                            label="Last Name"
                            error={errorField.lastName}
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="col-sm-12 col-form-label">
                        <Input
                            type="email"
                            name="email"
                            value={studentData.email}
                            onChange={onChangeHandler}
                            placeholder="Enter EmailID"
                            className="form-control"
                            label="Email"
                            error={errorField.email}
                            required
                        />
                    </div>
                    <div className="col-sm-12 col-form-label">
                        <Input
                            type="tel"
                            name="mobile"
                            value={studentData.mobile}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                                if (value.length <= 10) {
                                    onChangeHandler({
                                        target: { name: "mobile", value }
                                    });
                                }
                            }}
                            placeholder="Enter Mobile"
                            className="form-control"
                            label="Mobile"
                            maxLength={10}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            error={errorField.mobile}
                            required
                        />


                    </div>
                </div>

            </ModalBox>
        </>
    );
};

export default AddInterviewStudent;
